// @flow
// Needed for redux-saga es6 generator support
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "core-js/stable";
import "regenerator-runtime/runtime";
// import all 3rd party stuff
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import configureStore from "./store";
import rootSaga from "./sagas";
import axios from "axios";
import { unregister } from "./registerServiceWorker";
import Security from "./containers/Security";
import AppRoute from "./routes";
import "./index.css";
import "./styles/globals.css";
import "@fontsource/roboto";
import { BrowserRouter as Router } from "react-router-dom";
import Snackbar from "containers/Snackbar";
import GoogleAnalytics from "components/GoogleAnalytics";

// Import Mui Date Picker provider
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import red from "@mui/material/colors/red";

axios.defaults.baseURL =
    process.env.REACT_APP_SERVER || "https://localhost:9696";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

// we probably want to have this in a separate file as it grows
const initialState = {};

const { store, history } = configureStore(initialState);
store.runSaga(rootSaga);

const theme = createTheme({
    components: {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    overflow: "hidden",
                },
            },
        },
        MuiCollapse: {
            styleOverrides: {
                container: {
                    overflowX: "auto",
                    overflowY: "hidden",
                },
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            contained: {
                backgroundColor: "#164174",
                color: '#fff',
                '&:hover': {
                    backgroundColor: "#143356",
                    color: '#fff',
                },
            },
        },
    },
    MuiTypography: {
        styleOverrides: {
            root: {
                // fontSize: "1rem",
            },
        },
    },
    palette: {
        primary: {
            light: "#44a0ff",
            main: "#0061cc",
            dark: "#003f8a",
            // ... other palette properties
        },
        secondary: {
            light: "#90A4AE",
            main: "#607D8B",
            dark: "#455A64",
            // ... other palette properties
        },
        error: {
            light: red[300],
            main: red[500],
            dark: red[700],
        },
    },
});

const root = createRoot(document.getElementById("root"));

root.render(
    <ThemeProvider theme={theme}>
        <Router>
            <Provider store={store}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Security>
                        <AppRoute history={history} />
                    </Security>
                    <Snackbar />
                    <GoogleAnalytics />
                </LocalizationProvider>
            </Provider>
        </Router>
    </ThemeProvider>
);

unregister();